<template>
  <div class="footer">
    <div class="style-container">
      <div v-if="heads === 'true'">
        <img class="heads" src="@/assets/7Koepfe.svg" />
      </div>
    </div>
    <div v-if="type === 'red'" class="hotline small">{{ $t('common.footer.support') }}: 01764 078 40 66</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: ['type', 'heads']
}
</script>
